/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { BillingPlanWithUsage } from "./BillingPlanWithUsage";
export const BillingPlanWithUsageResponse = core.serialization.object({
    data: BillingPlanWithUsage,
});
